import React from 'react';
import FormWrapper from '../../../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import InputField from '../../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../../Components/Button/SubmitButton';
import { BankAccount } from './BankAccountSetup';

interface Props {
	defaultValues: BankAccount;
	onSuccess: (values: BankAccount) => void;
}

const BankAccountSetupDefaultForm: React.FC<Props> = ({
	defaultValues,
	onSuccess,
}) => {
	const validationSchema = yup.object({
		prefix: yup.string(),
		number: yup.string().required(),
		suffix: yup.string().required(),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
		defaultValues,
	});

	const handleOnSubmit = (values: any) => {
		onSuccess(values);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<div className='row mb-3'>
				<div className='col-md-3 col-12'>
					<InputField name='prefix' label='registration.account.prefix' />
				</div>
				<div className='col-md-6 col-12'>
					<InputField
						name='number'
						label='registration.account.number'
						isRequired
					/>
				</div>
				<div className='col-md-3 col-12'>
					<InputField
						name='suffix'
						label='registration.account.bank'
						isRequired
					/>
				</div>
			</div>
			<SubmitButton onSubmit={handleOnSubmit} title='base.shared.save' />
		</FormWrapper>
	);
};

export default BankAccountSetupDefaultForm;
